import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';

import { disabledColor } from '@zego/theme';

const spin = keyframes`
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
`;

const ButtonSpinner = styled('div')(
  {
    position: 'relative',
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    WebkitAnimation: `${spin} 1.3s linear infinite`,
    animation: `${spin} 1.3s linear infinite`,
  },
  props => ({
    border: `2px solid ${props.color || disabledColor(4)}`,
    borderTop: '2px solid transparent',
  }),
);

export default ButtonSpinner;
